import React from 'react'
import type { OportunidadesStats } from '../services/statsService'
import { useOportunidades } from './useOportunidades'
import { useMonitoring } from './useMonitoring'

export function useOportunidadesStats() {
  const { items: oportunidades, loading: loadingOpp, error: errorOpp } = useOportunidades()
  const { items: monitors, loading: loadingMon, error: errorMon } = useMonitoring()

  const stats: OportunidadesStats | null = React.useMemo(() => {
    if (!oportunidades || oportunidades.length === 0) {
      // Enquanto não há oportunidades carregadas, evitamos exibir números inconsistentes
      return null
    }

    const active = oportunidades.filter((it) => String(it.status || '').toLowerCase() === 'active')
    const totalActive = active.length
    const longActive = active.filter((it) => it.objective === 'Long').length
    const shortActive = active.filter((it) => it.objective === 'Short').length
    const monitoringActive = monitors.length

    return { totalActive, longActive, shortActive, monitoringActive }
  }, [oportunidades, monitors])

  const loading = loadingOpp || loadingMon || !stats
  const error = errorOpp || errorMon

  return { stats, loading, error }
}

